import React, { Component } from 'react';
import {FaIcon} from "../../FaIcon";
import {Spinner} from "../../Spinner";
import {HELP_DATA_NODE, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class DataNodeStatusClass extends Component {
    render() {
        const { data_node_status_data, t } = this.props;

        if (!data_node_status_data) {
            if(!this.props.hasConnection) {
                return (
                    <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('data_node.not_included_or_not_connected')}
                        </p>
                    </div>
                </div>
                );
            }

            return (
                <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('data_node.not_included_tooltip')}<br/><br/>{t('data_node.not_included_contact')}<br/><br/>
                            {t('data_node.description')}<br/><br />
                            &nbsp;&nbsp;➡️<LinkToArticle article={HELP_DATA_NODE}/>
                        </p>
                    </div>
                </div>
            );
        }

        const { status, completed_percentage } = data_node_status_data;

        if (status === "COMPLETE" || (completed_percentage && completed_percentage >= 100)) {
            return (
                <div className={"bu-cell-icon fa-icon status-ok"}>
                    <FaIcon iconName="check-circle"/>
                </div>
            );
        }

        if (status === "PROCESSING") {
            return (
                <div className={"bu-cell-icon fa-icon status-loading"}>
                    <Spinner color="positive small" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description">
                            {t('data_node.processing_tooltip', { percentage: completed_percentage || 0 })} <br/><br/>
                            {t('data_node.processing_connection_issue')}<br/>
                            {t('data_node.processing_contact')}
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className={"bu-cell-icon"}>
                <FaIcon iconName={"exclamation-triangle"} />
                 <div className="bu-tooltip">
                    <p className="tooltip-description">
                        {t('data_node.unknown_status')}
                    </p>
                </div>
            </div>
        );
    }
}

export const DataNodeStatus = withTranslation()(DataNodeStatusClass);